<template>
    <meta name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover">

    <div id="app">
        <home-view/>
<!--        <router-view/>-->
        <!--        <div style="height: 2rem;background-color: #f3f3f3;"></div>-->
    </div>
</template>

// eslint-disable-next-line
<script>

import HomeView from "@/views/HomeView.vue";

export default {
    name: 'App',
    data() {

    },
    methods: {},
    created() {

    },
    components: {HomeView},
}
</script>

<style>

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #f3f3f3;
    margin-top: 60px;
}

/**
 * 适配 iphone 底部安全区（指示条，配合index.html <meta name="viewport" ... />使用
 */


</style>
